export const MESSAGE_POPUP_CONDITION = {
    SHOW_ONCE: 0,
    ALWAYS_SHOW: 1,
};
export const USER_TYPE = {
    EMPLOYEE: 'employee',
    CANDIDATE: 'candidate'
}